import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { gsap } from 'gsap';

@Component({
  selector: 'fgb-fantasy-nav',
  templateUrl: './fantasy-nav.component.html',
  styleUrl: './fantasy-nav.component.scss',
})
export class FantasyNavComponent implements OnInit, AfterViewInit {
  @ViewChild('navContainer') navContainer!: ElementRef;
  @ViewChild('indicator') indicator!: ElementRef;

  constructor(private router: Router) {}

  ngOnInit() {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      requestAnimationFrame(() => {
        this.moveToActive();
      });
    });
  }

  ngAfterViewInit() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.moveToActive();
      });
    });
  }

  moveToActive() {
    if (!this.navContainer || !this.indicator) return;

    const container = this.navContainer.nativeElement;
    const indicator = this.indicator.nativeElement;

    const active = container.querySelector('.nav-item.active');

    if (!active || active.offsetWidth === 0) {
      requestAnimationFrame(() => this.moveToActive());
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();

    const x = activeRect.left - containerRect.left;

    gsap.to(indicator, {
      x,
      width: activeRect.width,
      duration: 0.4,
      opacity: 1,
      ease: 'power3.out',
    });
  }
}
